import axiosInstance, { axiosNAKBHOInstance } from "../../../interceptor/intercetptor-inctence";

export const getReportsService = (data) => {
	return axiosInstance.post(`healthcare_providers/investigation/uploaded-reports`, data);
}

export const getPatients = (data) => {
	return axiosNAKBHOInstance.post(`healthcare_providers/search/patient`, data)
}

export const getInvoiceService = (id) =>{
	return axiosInstance.get(`healthcare_providers/investigation/uploaded-reports/${id}`)
}